<template>
  <!--
    Leading tile of a comment's media strip when the comment has a recording attached and that
    recording has a finished 3D flyover. Mirrors the recording overview page's gallery thumbnail: the
    first video frame as a poster (`#t=0.1`, metadata-only preload so the strip stays cheap) with a
    centred play button, opening the shared full-screen player on click.
  -->
  <button type="button"
          class="flyover-thumb"
          aria-label="Play 3D flyover video"
          @click="play">
    <video class="flyover-thumb__poster"
           :src="posterSrc"
           muted
           playsinline
           preload="metadata"></video>
    <span class="flyover-thumb__play material-icons">play_arrow</span>
  </button>
</template>

<script>
import { openFlyoverVideoFullscreen } from '../../utils/openFlyoverVideoFullscreen';

export default {
  props: {
    videoUrl: {
      type: String,
      required: true,
    },
  },
  computed: {
    // Seeking a hair past 0 is what makes browsers paint a real frame rather than a black poster.
    posterSrc() {
      return `${this.videoUrl}#t=0.1`;
    },
  },
  methods: {
    play() {
      openFlyoverVideoFullscreen(this.videoUrl);
    },
  },
};
</script>

<style scoped>
.flyover-thumb {
  position: relative;
  display: block;
  flex-shrink: 0;
  width: 100px;
  height: 100px;
  padding: 0;
  border: none;
  border-radius: 8px;
  overflow: hidden;
  background: #000;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.flyover-thumb:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  z-index: 10;
}

.flyover-thumb__poster {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  pointer-events: none;
}

.flyover-thumb__play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  font-size: 24px;
  pointer-events: none;
}

/* Match CommentPhoto's responsive sizing so the strip stays a single row height. */
@media (max-width: 576px) {
  .flyover-thumb {
    width: 80px;
    height: 80px;
  }
}

@media (max-width: 380px) {
  .flyover-thumb {
    width: 70px;
    height: 70px;
  }
}
</style>
